import Pie3D from './pie3d';
import Doughnut3DDataset from '../_internal/datasets/doughnut3d';
class Doughnut3D extends Pie3D {
  /**
   * Provides the name of the chart extension
   *
   * @static
   * @return {string} The name of the chart extension
   */
  static getName () {
    return 'Doughnut3D';
  }

  /**
   * Sets the name of the component
   * @return {string} name
   */
  getName () {
    return 'Doughnut3D';
  }
  __setDefaultConfig () {
    super.__setDefaultConfig();
    let config = this.config;
    config.friendlyName = '3D Doughnut Chart';
    config.defaultDatasetType = 'Doughnut3D';
    config.singletonPlaceValue = false;
  }
  getDSdef () {
    return Doughnut3DDataset;
  }
}
export default Doughnut3D;
